module.exports = __webpack_public_path__ + "img/userImg.82d7033e.png";